export default __webpack_public_path__ + "static/media/facebook.5c853cf1.svg";